import React from 'react';
import { Tooltip, Typography } from '@mui/material';
import { OverflowChips } from '@/components/OverflowChips';
import DataGridMultiBrokerGroup from '@/components/table/DataGridComponents/DataGridMultiBrokerGroup';
import {
	formatDateTime,
	getDateSortValue,
} from '@/components/views/SettingsView/BrokerageUsersTable/helpers';

export const columns = [
	{
		field: 'feature',
		headerName: 'Feature',
		flex: 1,
		minWidth: 180,
		hideable: false,
	},
	{
		field: 'description',
		headerName: 'Description',
		flex: 2,
		minWidth: 240,
		hideable: true,
	},
	{
		field: 'active',
		headerName: 'Active',
		width: 110,
		sortable: true,
		align: 'left',
		headerAlign: 'left',
		display: 'flex',
		hideable: false,
	},
	{
		field: 'users',
		headerName: 'Users',
		flex: 1.4,
		minWidth: 220,
		sortable: false,
		display: 'flex',
		hideable: true,
		renderCell: ({ row }) => {
			const users = row.users ?? [];
			if (!users.length) {
				return <Typography variant='body1'>-</Typography>;
			}
			return (
				<Tooltip
					title={users
						.map((user) => user.name)
						.filter(Boolean)
						.join(', ')}
				>
					<OverflowChips
						items={users}
						limitTags={3}
						width='100%'
						height='100%'
						getLabel={(user) => user.name ?? user.email ?? ''}
					/>
				</Tooltip>
			);
		},
	},
	{
		field: 'brokerGroupIds',
		headerName: 'Broker groups',
		flex: 1.4,
		minWidth: 220,
		sortable: false,
		display: 'flex',
		hideable: true,
		renderCell: ({ row }) =>
			row.brokerGroupIds?.length ? (
				<DataGridMultiBrokerGroup brokerGroupIds={row.brokerGroupIds} showAdmin={false} />
			) : (
				<Typography variant='body1'>-</Typography>
			),
	},
	{
		field: 'createdWhen',
		headerName: 'Created Date',
		width: 190,
		display: 'flex',
		type: 'number',
		headerAlign: 'left',
		hideable: true,
		valueGetter: (_, row) => getDateSortValue(row.createdWhen),
		renderCell: ({ row }) => formatDateTime(row.createdWhen),
	},
];
